const studentsRoutes = [{
    path: "/Students/Summary",
    name: "StudentsSummary",
    component: require("@/components/Students/Summary/StudentsSummary").default
  },
  {
    path: "/Students/CreateStudent",
    name: "CreateStudent",
    component: require("@/components/Students/CreateStudent").default
  },
  {
    path: "/Students/Profile",
    name: "StudentProfile",
    component: require("@/components/Students/Profile/StudentProfile").default
  }
];

export default studentsRoutes;